import { Skeleton } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { isCourseProgramsIntersectsProfilePrograms } from "../../../components/common/utils/isProgramPresent";
import { AppContext } from "../../../context/ApplicationContext";
import CapPricingAndPaymentDetails from "./CapProgram/CapPricingAndPaymentDetails";
import ScholarInstructionsPayment from "./ScholarProgram/ScholarInstructionsPayment";

export default function PaymentPending() {
  const [isCapApplication, setCapApplication] = useState<null | boolean>(null);
  const state = useContext(AppContext)[0];
  useEffect(() => {
    if (
      isCourseProgramsIntersectsProfilePrograms(
        state.applicationData?.batch_campus.batch?.course?.course_programs,
        [
          {
            id: 4,
            name: "CAP",
          },
        ]
      )
    ) {
      setCapApplication(true);
    } else if (
      isCourseProgramsIntersectsProfilePrograms(
        state.applicationData?.batch_campus.batch?.course?.course_programs,
        [
          {
            id: 1,
            name: "Scholar",
          },
        ]
      )
    ) {
      setCapApplication(false);
    }
  }, [state.applicationData?.batch_campus.batch?.course?.course_programs]);
  return (
    <Skeleton isLoaded={isCapApplication === true || isCapApplication === false}>
      {isCapApplication ? (
        <CapPricingAndPaymentDetails />
      ) : isCapApplication === false ? (
        <ScholarInstructionsPayment />
      ) : null}
    </Skeleton>
  );
}
